var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCartIconPageCart(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 44,
    viewBox: "0 0 44 44",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M38.6465 12.8334C38.3297 12.2846 37.8761 11.8272 37.3299 11.5059C36.7837 11.1846 36.1635 11.0103 35.5298 11.0001H12.0632L10.9998 6.85677C10.8924 6.4568 10.6527 6.105 10.3198 5.85865C9.98691 5.6123 9.5804 5.48592 9.1665 5.5001H5.49984C5.01361 5.5001 4.54729 5.69325 4.20347 6.03707C3.85966 6.38089 3.6665 6.8472 3.6665 7.33343C3.6665 7.81966 3.85966 8.28598 4.20347 8.62979C4.54729 8.97361 5.01361 9.16677 5.49984 9.16677H7.77317L12.8332 27.9768C12.9406 28.3767 13.1803 28.7285 13.5132 28.9749C13.8461 29.2212 14.2526 29.3476 14.6665 29.3334H31.1665C31.5051 29.3324 31.8367 29.2377 32.1247 29.0597C32.4127 28.8817 32.6458 28.6274 32.7982 28.3251L38.8115 16.2984C39.0721 15.7521 39.1935 15.1498 39.1647 14.5452C39.1359 13.9406 38.9579 13.3525 38.6465 12.8334ZM30.0298 25.6668H16.0598L13.0715 14.6668H35.5298L30.0298 25.6668Z",
    fill: "#1E1E1E"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.75 38.5C15.2688 38.5 16.5 37.2688 16.5 35.75C16.5 34.2312 15.2688 33 13.75 33C12.2312 33 11 34.2312 11 35.75C11 37.2688 12.2312 38.5 13.75 38.5Z",
    fill: "#1E1E1E"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M32.0835 38.5C33.6023 38.5 34.8335 37.2688 34.8335 35.75C34.8335 34.2312 33.6023 33 32.0835 33C30.5647 33 29.3335 34.2312 29.3335 35.75C29.3335 37.2688 30.5647 38.5 32.0835 38.5Z",
    fill: "#1E1E1E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCartIconPageCart);
export default __webpack_public_path__ + "static/media/cart-icon_page_cart.e2fa2f05ce4fa6b13315ffebc6353fbc.svg";
export { ForwardRef as ReactComponent };